import React  from 'react';
import CurrencyComponentProto from './currency-proto.jsx';


export default function renderCurrencyInView(id, props) {
    return <CurrencyComponentProto renderMode="view" id={id} {...props} />;
}